import { AccountRemoveIcon } from './AccountRemoveIcon';

/**
 * author: REJack
 * id 0A1FDBBB-9E1C-480E-BC1D-725778D0851B
 * name account-remove
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-remove.svg
 * tags
 * - Account / User 
 */
export const UserRemoveIcon = AccountRemoveIcon;
export default UserRemoveIcon